import React from 'react';
import Card from 'src/common/refactoredComponents/card/Card.jsx';
import StyledText from 'src/common/refactoredComponents/styledText/StyledText';
import { accountNumberZeroTrimmer } from 'src/utils/util';
import Chip from 'src/common/refactoredComponents/chipComponent';
import {
    ShippingAddressAccountNumber,
    ShippingAddressLine,
} from 'src/pages/scheduleSurgery/components/shipping/Shipping.styled';
import { DARK_NAVY_FONT_COLOR, BLACK_FONT_COLOR, FONT_FAMILY_DEMI, FONT_FAMILY_REGULAR, SEMANTIC_TEXT_SMALL_PX, SMALL_TEXT_PX } from 'src/styles/fonts/MCFontConstants';

const ShippingAddressCard = (props) => {
    const { address, onCardSelection, isMobileDevice } = props;
    const trimmedShippingAddressId = accountNumberZeroTrimmer(
        address.shippingAddressId
    );

    return (
        <Card
            height={props.height}
            padding={'15px 19px 13px 21px'}
            border={
                props.showBorder ? '2px solid #1010EB' : '2px solid transparent'
            }
            borderRadius={'6px'}
            onCardClick={onCardSelection}
            cursor={'pointer'}
            isShippingCard={true}
            margin={'0px'}
            id = {`surgery-shipping-address-card-${address.accountName}`}
        >
            <ShippingAddressAccountNumber>
                <StyledText
                    className="schedule-surgery-shipping-attention-dt-mask"
                    fontColor={DARK_NAVY_FONT_COLOR}
                    fontSize={SMALL_TEXT_PX}
                    fontFamily={FONT_FAMILY_DEMI}
                    textAlign={'initial'}
                >
                    {`${address.accountName} `}
                    <span style={{ fontFamily: 'AvenirNextWorld Italic' }}>
                        {trimmedShippingAddressId}
                    </span>
                </StyledText>
            </ShippingAddressAccountNumber>
            <ShippingAddressLine>
                <div>
                    {address.addressLine1 ? (
                        <StyledText
                            className="schedule-surgery-shipping-address-dt-mask"
                            fontColor={BLACK_FONT_COLOR}
                            fontSize={SEMANTIC_TEXT_SMALL_PX}
                            fontFamily={FONT_FAMILY_REGULAR}
                            letterSpacing={'-0.1px'}
                            textAlign={'initial'}
                        >
                            {address.addressLine1}
                        </StyledText>
                    ) : null}

                    <StyledText
                            className="schedule-surgery-shipping-city-state-dt-mask"
                        fontColor={BLACK_FONT_COLOR}
                        fontSize={SEMANTIC_TEXT_SMALL_PX}
                        fontFamily={FONT_FAMILY_REGULAR}
                        letterSpacing={'-0.1px'}
                        textAlign={'initial'}
                        width={isMobileDevice ? '208px' : undefined}
                    >
                        {/* replacing hyphen with non-breaking hyphen to prevent line break on hyphen */}
                        {`${address.city}, ${
                            address.region ? address.region : ''
                        } ${address.postalCode}`.replace('-', '\u2011')}
                    </StyledText>
                </div>
                {address.defaultAddress && (
                    <Chip
                        borderRadius="6px"
                        label="Default"
                        color="#4F4F4F"
                        mobilePadding={'0px 2px'}
                        desktopPadding={'0px 2px'}
                        mobileMargin={
                            isMobileDevice ? '0px' : '55px 0px 0px 0px'
                        }
                        desktopMargin={'0px'}
                        position={isMobileDevice ? 'absolute' : 'unset'}
                        bottom={isMobileDevice ? '15px' : 'unset'}
                        right={isMobileDevice ? '18px' : 'unset'}
                    />
                )}
            </ShippingAddressLine>
        </Card>
    );
};

export default ShippingAddressCard;
